import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { TableHeaderCell, Dropdown, ActionableBox, Box } from "@contember/ui";
import { FilterIcon, ChevronUpIcon, ChevronDownIcon } from "lucide-react";
import { useMemo, createElement } from "react";
import { cycleOrderDirection } from "./DataGridOrderDirection.js";
function DataGridHeaderCell({
  ascOrderIcon,
  descOrderIcon,
  emptyFilterArtifact,
  environment,
  filterArtifact,
  filterRenderer,
  hasFilter,
  header,
  headerJustification,
  orderState,
  setFilter,
  setOrderBy,
  shrunk
}) {
  const buttonProps = useMemo(() => ({
    intent: hasFilter ? void 0 : "default",
    distinction: "seamless",
    size: "small",
    children: /* @__PURE__ */ jsx(
      FilterIcon,
      {
        fill: hasFilter ? "currentColor" : "none"
      }
    )
  }), [hasFilter]);
  return /* @__PURE__ */ jsx(TableHeaderCell, { scope: "col", justification: headerJustification, shrunk, children: /* @__PURE__ */ jsxs("span", { style: { display: "flex", justifyContent: "flex-start", gap: ".25em" }, children: [
    /* @__PURE__ */ jsxs("span", { onClick: (e) => setOrderBy(cycleOrderDirection(orderState?.direction ?? null), e.ctrlKey || e.metaKey), style: { cursor: "pointer" }, children: [
      header,
      " ",
      orderState && /* @__PURE__ */ jsxs(Fragment, { children: [
        {
          asc: ascOrderIcon ?? defaultAscIcon,
          desc: descOrderIcon ?? defaultDescIcon
        }[orderState.direction],
        orderState.index !== void 0 ? `(${orderState.index + 1})` : null
      ] })
    ] }),
    filterRenderer && /* @__PURE__ */ jsx(
      Dropdown,
      {
        buttonProps,
        renderContent: ({ requestClose }) => /* @__PURE__ */ jsx(
          ActionableBox,
          {
            onRemove: () => {
              setFilter(void 0);
              requestClose();
            },
            children: /* @__PURE__ */ jsx(Box, { padding: false, background: false, border: false, header: /* @__PURE__ */ jsxs(Fragment, { children: [
              "Filter: ",
              header
            ] }), children: createElement(filterRenderer, {
              filter: filterArtifact === void 0 ? emptyFilterArtifact : filterArtifact,
              setFilter,
              environment
            }) })
          }
        )
      }
    )
  ] }) });
}
const defaultAscIcon = /* @__PURE__ */ jsx(ChevronUpIcon, {});
const defaultDescIcon = /* @__PURE__ */ jsx(ChevronDownIcon, {});
export {
  DataGridHeaderCell
};
//# sourceMappingURL=DataGridHeaderCell.js.map
